module.exports = __webpack_public_path__ + "img/assembly@2x.f1351005.png";